var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "32", height: "32", viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.167 15.844a1.7 1.7 0 0 1 1.7-1.7H24.5a7.2 7.2 0 0 1 7.2 7.2v3.211a1.7 1.7 0 1 1-3.4 0v-3.21a3.8 3.8 0 0 0-3.8-3.8H3.867a1.7 1.7 0 0 1-1.7-1.7z", fill: "#EDEDED" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.047 7.798a1.7 1.7 0 0 1 0 2.404l-5.694 5.694 5.745 6.266A1.7 1.7 0 0 1 7.59 24.46L.747 16.993a1.7 1.7 0 0 1 .051-2.35l6.845-6.845a1.7 1.7 0 0 1 2.404 0z", fill: "#EDEDED" })
  );
});